module.exports = __webpack_public_path__ + "static/media/preview@768.c5527135.png";